import { deepMerge } from "./deepMerge";

export const CHART_PALETTE = {
  // turnover / positive currency series
  seriesGreen: "#84d69e",
  // P&L / secondary currency series
  seriesPurple: "#af7ac5",
  // ranked bars, ordered blue -> pink
  bars: ["#6177e8", "#4f62c9", "#9b59b6", "#bf3880", "#ee72bc"],
};

export const CHART_FONT = "Poppins-regular";

const AXIS_TICKS = { color: "#92929e", font: { size: 11 } };
const GRID_COLOR = "rgba(255,255,255,0.06)";

// Dark-theme defaults shared by every chart. Consumers pass an override object
// (see buildChartOptions) for the bits specific to their chart.
export const baseChartOptions: Record<string, unknown> = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: { grid: { display: false }, ticks: { ...AXIS_TICKS } },
    y: { grid: { color: GRID_COLOR }, ticks: { ...AXIS_TICKS } },
  },
  plugins: {
    legend: { display: false },
    title: { display: false },
    datalabels: { display: false },
    tooltip: {
      enabled: true,
      backgroundColor: "#252729",
      padding: 12,
      titleFont: { family: CHART_FONT, size: 13, weight: 600 },
      bodyFont: { family: CHART_FONT, size: 13 },
    },
  },
};

export function buildChartOptions(
  overrides?: Record<string, unknown>,
): Record<string, unknown> {
  return deepMerge(baseChartOptions, overrides);
}
